import React from "react";

const RegisterSuccess = () => {
  setTimeout(() => {
    window.location.href = "/login";
  }, 5000);
  return (
    <div style={{ textAlign: "center", paddingTop: "5%" }}>
      <h2>
        Uspješno ste se registrovali, provjerite Vašu e-mail adresu kako bi
        verifikovali nalog.
      </h2>
    </div>
  );
};

export default RegisterSuccess;
